// extracted by mini-css-extract-plugin
module.exports = {"titlePosition":"OffsetFieldForm_titlePosition__dQmiF","colPadding":"OffsetFieldForm_colPadding__biod7"};